import React, { useState, useContext, useEffect } from "react";

import TenantContext from "../../../utils/tenantContext";

const BRANDING_COMPANY_NAME = process.env.REACT_APP_BRANDING_COMPANY_NAME;
const BRANDING_COMPANY_WEBSITE = process.env.REACT_APP_BRANDING_COMPANY_WEBSITE;

const DEFAULT_PRIVACY_POLICY_URL = "https://example.com/privacy-policy";
const DEFAULT_TERMS_AND_CONDITIONS_URL = "https://example.com/terms-and-conditions";

const Footer = () => {
  let date = new Date();

  const {tenant} = useContext(TenantContext);
  const [privacyPolicyUrl, privacyPolicyUrlSET] = useState("");
  const [termsAndConditionsUrl, termsAndConditionsUrlSET] = useState("");

  useEffect(() => {
		if(tenant) {
			privacyPolicyUrlSET(tenant.privacy_policy_url || DEFAULT_PRIVACY_POLICY_URL);
      termsAndConditionsUrlSET(tenant.terms_and_conditions_url || DEFAULT_TERMS_AND_CONDITIONS_URL);
		}
	}, [tenant]);

  return (
    <footer className="footer text-left">
      <strong>
        Copyright © {date.getFullYear()} &nbsp;
        <a
          href={BRANDING_COMPANY_WEBSITE}
          target="_blank"
          rel="noopener noreferrer"
        >
          {BRANDING_COMPANY_NAME}&nbsp;
        </a>
      </strong>
      <span>All rights reserved.</span> |
      <a style={{padding: '0 0 0 4px'}} href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a> |
      <a style={{padding: '0 0 0 4px'}} href={termsAndConditionsUrl} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
    </footer>
  );
};

export default Footer;